import {Action} from '@ngrx/store';
import {DressCodeState} from '../states/dress-code-state';
import {GetDressCodeSuccessAction} from '../actions/dress-code/get-dress-code-success-action';
import {GetDressCodeErrorAction} from '../actions/dress-code/get-dress-code-error-action';
import {UpdateDressCodeAction} from '../actions/dress-code/update-dress-code-action';
import {UpdateDressCodeErrorAction} from '../actions/dress-code/update-dress-code-error-action';
import {GetDressCodeAction} from '../actions/dress-code/get-dress-code-action';
import {Deserialize, Serialize} from 'cerialize';

const initialState = new DressCodeState();

export function DressCodeReducer(serializedState: any = Serialize(initialState), action: Action): any {
  const state: DressCodeState = Deserialize(serializedState, DressCodeState);

  switch (action.type) {
    case GetDressCodeAction.type:
      state.ready = false;
      state.error = null;
      break;

    case GetDressCodeSuccessAction.type:
      state.ready = true;
      state.dressCode = (<GetDressCodeSuccessAction>action).dressCode;
      state.error = null;
      break;

    case GetDressCodeErrorAction.type:
      state.ready = true;
      state.error = (<GetDressCodeErrorAction>action).error;
      break;

    case UpdateDressCodeAction.type:
      state.ready = false;
      state.error = null;
      break;

    case UpdateDressCodeErrorAction.type:
      state.ready = true;
      state.error = (<UpdateDressCodeErrorAction>action).error;
      break;

    default:
      return serializedState;
  }

  return Serialize(state);
}
